module.exports = __webpack_public_path__ + "img/broadcast-work-icon7.a3c37365.png";